<template>
    <div>
        <vue-bootstrap-typeahead
          @change="selectRede"
          :data="listRede"
          v-model="queryRede"
          size="sm"
          :serializer="r => showRede(r)"
          :minMatchingChars="0"
          :placeholder="placeholder"
          @hit="rede = $event"
          @input="rede"
        >
          <template slot="append">
            <i class="fas-fa-close"></i>
          </template>
        </vue-bootstrap-typeahead>
    </div>
</template>
<script>
import eventBus from '@/event-bus'

export default {
  props: {
    placeholder: {
      type: String,
      default: 'Informe a rede'
    }
  },
  computed: {
    redeAdmin () {
      return this.$store.getters.redeAdmin
    }
  },
  data () {
    return {
      listRede: [],
      queryRede: '',
      rede: null
    }
  },
  watch: {
    rede (newRede) {
      this.queryRede = this.showRede(newRede)
      this.selectRede()
    }
  },
  methods: {
    showRede (rede) {
      return `${rede.nomeRede} ${rede.localAtendimento} ${rede.cidade}/${rede.uf}`
    },
    selectRede () {
      this.$store.dispatch('setLoading', true)
      this.$store.dispatch('setRedeAdmin', this.rede)
        .then(async () => {
          await this.$store.dispatch('loadDadosRede', this.redeAdmin._id)
          eventBus.$emit('loadDadosCredenciado.selectRede', this.rede)
          this.$store.dispatch('setLoading', false)
        })
    }
  },
  async created () {
    if (this.redeAdmin) {
      this.rede = this.redeAdmin
    }

    this.listRede = await this.$store.dispatch('listRedeAdmin')
  }
}
</script>




// WEBPACK FOOTER //
// src/components/shared/listRedeAdmin.vue